// vue-api/src/refreshToken.ts
import { api } from './api'; // 假設你的 apiInstance 在這裡
export async function refreshToken(baseURL) {
    try {
        // 💡 加上 _skipGlobalError: true，讓攔截器第一時間跳過此請求，達成雙重保險
        const res = await api().post(`/api/client/refresh`, {}, {
            _skipGlobalError: true
        });
        return res.data;
    }
    catch (err) {
        throw err;
    }
}
// import axios from 'axios';
// import Cookies from 'js-cookie';
// export async function refreshToken(baseURL: string) {
//   try {
//     const res = await axios.post(
//       `${baseURL}/api/client/refresh`,
//       {},
//       {
//         withCredentials: true, // ⭐ 關鍵（帶 cookie）
//       }
//     );
//   } catch (err) {
//     throw err;
//   }
// }
